import type { ArticleCardProps } from '../ArticleCard/ArticleCard';
import styles from '../ArticleList.module.css';
import { PictureProfiles } from '~/Partials/Picture/PictureProfiles';

export const MAX_ITEMS_TO_DISPLAY = 3;

export const resolveCardDisplayProps = (
    currentIndex: number,
    totalCount: number,
    isMobile: boolean
): Required<Pick<ArticleCardProps, 'layout' | 'pictureRatio' | 'pictureProfile'>> => {
    if (isMobile) {
        return {
            layout: 'vertical',
            pictureRatio: currentIndex === 0 ? '3x4' : '16x9',
            pictureProfile: currentIndex === 0 ? PictureProfiles.vertical : PictureProfiles.horizontal,
        };
    }

    switch (totalCount) {
        case 1:
            return {
                layout: 'horizontal',
                pictureRatio: '16x9',
                pictureProfile: PictureProfiles.horizontal,
            };
        case 2:
            return currentIndex === 0
                ? {
                      layout: 'fullWidth',
                      pictureRatio: '16x9',
                      pictureProfile: PictureProfiles.eightOfTwelveColumnsElementHorizontal,
                  }
                : {
                      layout: 'vertical',
                      pictureRatio: '3x4',
                      pictureProfile: PictureProfiles.fourOfTwelveColumnsElementVertical,
                  };
        case 3:
            if (currentIndex === 0) {
                return {
                    layout: 'vertical',
                    pictureRatio: '16x9',
                    pictureProfile: PictureProfiles.fiveOfTwelveColumnsElementVertical,
                };
            }

            if (currentIndex === 1) {
                return {
                    layout: 'vertical',
                    pictureRatio: '3x4',
                    pictureProfile: PictureProfiles.fourOfTwelveColumnsElementVertical,
                };
            }

            return {
                layout: 'vertical',
                pictureRatio: '2x3',
                pictureProfile: PictureProfiles.threeOfTwelveColumnsElementVertical,
            };
        default:
            throw new Error(`Invalid number of items: ${totalCount}`);
    }
};

export const resolveListLayoutClass = (totalCount: number) => {
    switch (totalCount) {
        case 1:
            return styles['ListVariant--oneColumn'];
        case 2:
            return styles['ListVariant--twoColumns'];
        default:
            return styles['ListVariant--threeColumns'];
    }
};
